__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "workforceops";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@scfe-common/micro-frontend-utils", "0.2.3", () => (__webpack_require__.e(592).then(() => (() => (__webpack_require__(90592))))));
			register("@spx-portal/shared-context", "0.1.0", () => (Promise.all([__webpack_require__.e(142), __webpack_require__.e(964)]).then(() => (() => (__webpack_require__(88163))))));
			register("@spx-portal/shared-hooks", "0.2.5", () => (Promise.all([__webpack_require__.e(142), __webpack_require__.e(613), __webpack_require__.e(383), __webpack_require__.e(669), __webpack_require__.e(364)]).then(() => (() => (__webpack_require__(82549))))));
			register("@spx-portal/shared-utils", "0.1.16", () => (Promise.all([__webpack_require__.e(142), __webpack_require__.e(613), __webpack_require__.e(285), __webpack_require__.e(707)]).then(() => (() => (__webpack_require__(79523))))));
			register("@ssc-ui/charts-react", "2.0.4-alpha.18", () => (__webpack_require__.e(740).then(() => (() => (__webpack_require__(65740))))));
			register("@ssc/sound-alert", "0.0.2", () => (__webpack_require__.e(870).then(() => (() => (__webpack_require__(20870))))));
			register("ahooks", "3.7.8", () => (Promise.all([__webpack_require__.e(142), __webpack_require__.e(613), __webpack_require__.e(167), __webpack_require__.e(9), __webpack_require__.e(131)]).then(() => (() => (__webpack_require__(44009))))));
			register("classnames", "2.3.2", () => (__webpack_require__.e(739).then(() => (() => (__webpack_require__(80739))))));
			register("dayjs", "1.11.10", () => (__webpack_require__.e(142).then(() => (() => (__webpack_require__(72712))))));
			register("decimal.js", "10.4.3", () => (__webpack_require__.e(765).then(() => (() => (__webpack_require__(33765))))));
			register("immer", "10.0.3", () => (__webpack_require__.e(142).then(() => (() => (__webpack_require__(31696))))));
			register("lodash", "4.17.21", () => (__webpack_require__.e(142).then(() => (() => (__webpack_require__(57550))))));
			register("react-flip-toolkit", "7.2.4", () => (__webpack_require__.e(717).then(() => (() => (__webpack_require__(11717))))));
			register("zustand", "4.4.6", () => (__webpack_require__.e(660).then(() => (() => (__webpack_require__(13660))))));
			initExternal(8370);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};